import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';
import { AppConsts } from '../../shared/AppConsts';
import { DateTimeService } from '../../shared/services/datetime.service';
import { AuthenticationService } from '../_services/authentication.service';
import { timeout, catchError, tap } from 'rxjs/operators';
import { AlertService } from '../../shared/services/alert.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    authenticationService: AuthenticationService;
    dateTimeService: DateTimeService;

    constructor(private injector: Injector, private alertService: AlertService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url !== AppConsts.appSettingsUrl) {
            this.authenticationService = this.injector.get(AuthenticationService);
            this.dateTimeService = this.injector.get(DateTimeService);

            // add authorization header with jwt token if available
            const currentUser = this.authenticationService.currentUserValue;
            // console.log("JwtInterceptor: Insertando token");
            if (currentUser && currentUser.token) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${currentUser.token}`
                    }
                });
            }

            request = request.clone({
                setHeaders: {
                    'The-Timezone-IANA': this.dateTimeService.getTimeZone()
                }
            });
        }
        var listadoExportacion = [
            '/api/numeropartes/export', 
            '/api/detallado/frames',
            '/api/Report/EtiquetasConNumerosParte/list',
            '/api/Report/SecuenciadoHojasControl/pdf',
            '/api/report/detallado/data',
            '/api/escanear/partes-faltantes',
            '/api/Report/TablaProductividad/list',
            '/api/Report/Productividad/list/export',
            '/api/reportes/sabana-dollys/export',
            '/api/reportes/sabana-dollys-resumen/export',
            '/api/planes-carga/paginado',
            '/api/programas/secuenciados',
            '/api/reiniciar/secuencias',
            '/api/dynamicselect/getoptions',
            '/api/dollys/validar-cierre',
            '/api/dolly/cerrar-dollies',
            '/api/dollys/estatus/EMBARQUE',
            '/api/dollys/validar-densidad',
            '/api/dollys/asignacion-dolly',
            ''
        ];

        return next.handle(request).pipe(
            // Solo aplicar timeout si NO es la URL de exportación
            listadoExportacion.some(url => request.url.includes(url)) 
                ? tap(() => {}) // NO aplicar ningún timeout para exportaciones / otras URLs listadas
                : this.getTimeoutByUrl(request.url) > 0 
                    ? timeout(this.getTimeoutByUrl(request.url))
                    : tap(() => {}), // No-op si timeout es 0
            catchError(err => {
                if (err.name === 'TimeoutError') {
                    // Pollings de segundo plano (dashboard): no interrumpir con modal si no hay conexión,
                    // solo dejar constancia en consola. El componente ya maneja el error en su subscribe.
                    const listadoTimeoutSilencioso = [
                        '/api/dashboard/inventario-secuenciado',
                        '/api/dashboard/intervalo-actualizacion'
                    ];
                    if (listadoTimeoutSilencioso.some(url => request.url.includes(url))) {
                        console.error('Timeout en petición de fondo:', request.url, err.message);
                    } else {
                        this.alertService.error(err.message);
                    }
                }
                return throwError(err);
            })
        );

        // return next.handle(request).pipe(timeout(this.getTimeoutByUrl(request.url)));
    }

    getTimeoutByUrl(url: string): number {
        let res = AppConsts.timeouts.default;

        if (AppConsts.timeouts.urls.length > 0) {
            const urlTimeout = AppConsts.timeouts.urls.find(p => url.indexOf(p.url) > 0);

            if (urlTimeout) {
                res = urlTimeout.timeout;
            }
        }

        return res;
    }
}
